import { gsap } from 'gsap';
import { version } from './version';
import './types';

export class Transition {
  /**
   * @constructor
   * @class Transition
   * @classdesc Base transition settings
   * @param {options} options
   */
  constructor(options) {
    const defaultOptions = {
      element: '#wb-barba-transition',
      duration: 0.75,
      spinner: true,
      useVars: false,
    };

    this.options = { ...defaultOptions, ...options };
    this._version = version;
    this.bindSpinnerListener();
  }

  bindSpinnerListener() {
    const { spinner } = this.options;

    if (!spinner) return;

    document.addEventListener('barbaAnimInEnd', this.addSpinner.bind(this));
    document.addEventListener('barbaAnimOutStart', this.removeSpinner.bind(this));
  }

  /**
   * Checks if there is a transition container with the options selector, otherwise appends it to the main tag
   * @returns {HTMLElement}
   */
  createTransitionContainer() {
    const { element } = this.options;
    let container = document.querySelector(element);

    if (container) return container;

    const name = element.substring(1);
    container = document.createElement('div');
    container.classList.add(name);
    container.setAttribute('id', name);

    document.querySelector('body').appendChild(container);
    return container;
  }

  /**
   * Gets the transition container
   * @returns {HTMLElement}
   */
  getTransitionContainer() {
    const { element } = this.options;
    return document.querySelector(element);
  }

  _getOptionValue(option) {
    const { useVars } = this.options;
    const value = this.options[option];

    if (useVars) {
      const cleanCssVar = value.replace('--', '');
      return getComputedStyle(document.querySelector('body')).getPropertyValue(`--${cleanCssVar}`);
    }

    return this.options[option];
  }

  /**
   * Adds spinner at the end of the "animation in"
   * @returns {HTMLElement}
   */
  addSpinner() {
    const spinner = document.createElement('div');
    const container = this.getTransitionContainer();

    gsap.set(spinner, { attr: { class: 'wb-transition-spinner' }, opacity: 0 });
    container.appendChild(spinner);
    gsap.to(spinner, { opacity: 1, duration: 0.35 });

    return spinner;
  }

  /**
   * Removes spinner at the start of the "animation out"
   */
  removeSpinner() {
    const spinner = document.querySelector('.wb-transition-spinner');

    gsap.to(spinner, {
      opacity: 0,
      duration: 0.35,
      onComplete: () => {
        spinner.remove();
      },
    });
  }
}
